<template>
    <!-- Estado vazio de tela inteira no novo layout (2026-09-13, "vamos dar uma modernizada nas
         listas vazias do sistema"): bloco centralizado com ícone numa bolha, título, uma frase,
         o botão principal em primary (os demais outline-primary) e os benefícios como chips.
         As props são as mesmas de antes, então as telas continuam funcionando; o `variant` dos
         botões passou a ser ignorado (um primary só), exceto `danger`, da exclusão de dados. O que cada tela precisa
         rever são os textos: título curto, uma frase, botão com verbo + entidade
         ("Adicionar transportadora") e três benefícios curtos, sem "E muito mais...". Com
         `saibaMais` aparece um "Saiba mais" outline-primary ao lado da ação que abre o modal
         informativo (ListaVaziaSaibaMais). -->
    <!-- Tudo dentro de um card branco ("deixe essa parte dentro de um card branco", 2026-09-13) -->
    <b-card
        class="mt-2"
        body-class="lista-vazia-tela text-center"
    >
        <div
            v-if="icone"
            class="bolha-vazia mx-auto"
            :class="classeIcone"
        >
            <i :class="`fa ${icone}`" />
        </div>
        <slot name="title">
            <h4
                v-if="titulo"
                class="titulo-vazio"
                :class="classeTitulo"
            >
                {{ titulo }}
            </h4>
        </slot>
        <p
            v-if="descricao"
            class="text-muted descricao-vazia mx-auto"
            v-html="descricao"
        />
        <!-- Contêiner sempre do componente: o slot #botoes substitui só os botões, e o "Saiba mais"
             e o espaçamento continuam valendo para quem usa o slot (backup, exclusão de dados) -->
        <div
            v-if="botoes || saibaMais || $slots.botoes"
            class="botoes-vazio d-flex flex-wrap justify-content-center align-items-center"
        >
            <slot name="botoes">
                    <b-button
                        v-for="(botao, index) in botoes"
                        :key="index"
                        size="md"
                        :href="botao.link"
                        :variant="botao.variant == 'danger' ? 'danger' : (index == 0 ? 'primary' : 'outline-primary')"
                        :class="botao.class"
                        :target="botao.target ? botao.target : '_self'"
                    >
                        <i
                            v-if="botao.icone"
                            class="mr-1"
                            :class="`fa ${botao.icone}`"
                        />
                        <span v-html="botao.texto" />
                    </b-button>
            </slot>
                <!-- "Saiba mais" ao lado da ação principal abre o modal informativo com o conteúdo
                     que a tela passa em `saibaMais` (2026-09-13) -->
                <b-button
                    v-if="saibaMais"
                    variant="outline-primary"
                    size="md"
                    @click="abreSaibaMais"
                >
                    Saiba mais
                </b-button>
        </div>
        <slot name="lista">
            <!-- Benefícios como cartões: ícone num quadrado tingido, título em 600 e uma frase
                 ("as opções de baixo do botão coloque nesse padrão", 2026-09-13). Item pode ser
                 string (vira só o título) ou { icone, titulo, texto, cor } -->
            <div
                v-if="lista && lista.length"
                class="beneficios-vazio"
            >
                <small
                    v-if="tituloLista"
                    class="text-muted d-block mb-2"
                >
                    {{ tituloLista }}
                </small>
                <div class="cartoes-beneficio">
                    <div
                        v-for="(item, index) in lista"
                        :key="index"
                        class="cartao-beneficio text-left"
                    >
                        <span
                            class="icone-beneficio"
                            :class="'tint-' + (item.cor || cores[index % cores.length])"
                        >
                            <i :class="`fa ${item.icone || 'fa-check'}`" />
                        </span>
                        <div>
                            <strong class="d-block">{{ item.titulo || item }}</strong>
                            <small
                                v-if="item.texto"
                                class="text-muted"
                            >
                                {{ item.texto }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </slot>
    </b-card>
</template>
<script>
export default {
    props: {
        icone: {
            default: null
        },
        classeIcone: {
            default: null
        },
        titulo: {
            default: null
        },
        classeTitulo: {
            default: null
        },
        descricao: {
            default: null
        },
        botoes: {
            default: null
        },
        tituloLista: {
            default: null
        },
        lista: {
            default: null
        },
        // { titulo, icone, topicos: [{ titulo, texto }] } para o modal "Saiba mais"
        saibaMais: {
            type: Object,
            default: null
        },
        // Obsoletas desde 2026-09-13 (vídeo tutorial removido: "esses tour e botão de vídeo tutorial
        // vão sair todos"). Mantidas para não quebrar quem ainda passa.
        ajuda: {
            default: true
        },
        possuiVideoTutorial: {
            default: true
        },
        urlVideoTutorial: {
            default: function () {
                return {
                    module: this.$urlBase,
                    controller: this.$url.controller,
                    action: this.$url.action || 'index'
                }
            }
        }
    },
    methods: {
        abreSaibaMais() {
            this.$modal.show(() => import('./ListaVaziaSaibaMais'), 'md', this.saibaMais)
        }
    },
    data() {
        return {
            cores: ['lilas', 'azul', 'verde']
        }
    }
}
</script>
<style lang="scss" scoped>
.lista-vazia-tela {
    padding: 48px 24px 24px;
}
.titulo-vazio,
.descricao-vazia,
.botoes-vazio {
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.bolha-vazia {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: var(--cinza-superficie, #f7f7f7);
    border: 1px solid var(--cinza-borda, #dee2e6);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    i {
        font-size: 40px;
        color: var(--cor-primaria, #16537e);
    }
}
.titulo-vazio {
    font-weight: 600;
    margin-bottom: 8px;
}
.descricao-vazia {
    max-width: 520px;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 20px;
}
.botoes-vazio {
    gap: 8px;
    margin-bottom: 28px;
}
.beneficios-vazio {
    max-width: 1100px;
    margin: 0 auto;
}
.cartoes-beneficio {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px;
}
.cartao-beneficio {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border: 1px solid var(--cinza-borda, #dee2e6);
    border-radius: var(--raio-lg);
    background: #fff;
    strong {
        font-size: 0.95rem;
        margin-bottom: 2px;
    }
    small {
        line-height: 1.4;
    }
}
.icone-beneficio {
    flex: none;
    width: 36px;
    height: 36px;
    border-radius: var(--raio);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
}
.tint-lilas { background: #ede9fe; color: #6d28d9; }
.tint-azul { background: #dbeafe; color: #1d4ed8; }
.tint-verde { background: #dcfce7; color: #15803d; }
</style>
